import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LogoutModel from './LogoutModel';
import DocumentVerificationModal from './DocumentVerificationModal';
import { loginCredential, searchCredential, bagCredential, lrtBagTypeCredential, redirectToPageCredentials, moduleAndLoginDivDisabled } from '../ReduxState';
import { Button, Modal } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import { useHistory, useLocation } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css 
import { fncGetBookingFromState, fncAddBaggage, fncRemoveBaggage, fncUpdateBaggage, fncConfirmBaggageApi, fncCheckInPassengerApi, fncCheckInBaggageApi, fncSaveChangesApi, FncSearchApi } from '../Utility/ApiCall.js';
import { fncAssignSearchedCheckboxes, fncBagStatus ,fncPageNavigations, shortcutKeyForPage, shortcutKeys, isInternationalFlight, checkinModule, checkPassengerStatus, haveTravelDocs, fncCheckIfTokenIsExpired, fncCheckSearchedFlightDetailsEmpty, fncFocusElementDependsOnPathLocation, shortcutKeysForPageNavigation, shortcutKeysforHumburgerMenu} from '../Utility/CommonFun.js';


function Bags({ handleSideMenu }) {
    let history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch()
    const [triggerModal, settriggerModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState("");
    const [show, setShow] = useState(false);
    const [st_UserID, setSelectedUSERID] = useState(0);
    const [modalTitle, setModalTitle] = useState("Add");    
    const [st_Destination, setSelectedDestination] = useState([{}]);
    const isBagAddedInState = useSelector(state => state.search.isBagAdded);
    const RoleCode = useSelector(state => state.login.RoleCode);
    let lrtBagType = useSelector(state => state.search.lrtBagTypeForPassenger);
    const [st_BagTypes, setBagTypes]= useState([
        {
            Name:"STND",
            IsSelected:true
        },
        {
            Name:"LRT",
            IsSelected:false   
        }
    ]);
    const [AddBags, setAddBags] = useState([{}]);
    const [AddNewBags, setNewBags] = useState([]);
    const [EditBagsData, setEditBagsData] = useState({});
    const [updatedBagTypeValue, setupdatedBagTypeValue] = useState("");
    const [updatedBaggageWeightTextbox, setupdatedBaggageWeightTextbox] = useState("");
    const [st_BaggageAllowance, setBaggageAllowance] = useState(0);
    const [st_BaggageRemaining, setBaggageRemaining] = useState(0);
    const [st_ExcessBaggage, setExcessBaggage] = useState(0);
    const [st_selectedPassengerCount, setselectedPassengerCount] = useState(0);
    const [showDeletePopUp, setshowDeletePopUp] = useState(false);
    const UserBoardingRights = useSelector(state => state.login.BoardingRights);
    const UserRights = useSelector(state => state.login.CheckInRights);
    const stSearchedRecordData = useSelector(state => state.search.SearchedRecordData);
    const SearchedSelectedPassengerData = useSelector(state => state.selectedpassenger.SelectedPassengerData);
    const docVerified = useSelector(state => state.docVerify.documentsVerified);
    // debugger
    const SearchedFlightDetails = useSelector(state => state.search.SearchedFlightDetails);
    const selectedModule = useSelector(state => state.login.Module);
    const IsModulAndLoginDivDisabled = useSelector(state => state.login.IsModulAndLoginDivDisabled);
    const [bagsToAdd, setBagsToAdd] = useState(0);
    const weightType = "Kilograms";
    const w = window.innerWidth;
    const onCloseRef = useRef(null);
    const [deletePopup, setDeletePopup] = useState(false);
    const [JourneyKeyforDeleteBaggage, setJourneyKeyforDeleteBaggage] = useState('')
    const [BaggageKeyforDeleteBaggage, setBaggageKeyforDeleteBaggage] = useState('')
    const [PassengerKeyforDeleteBaggage, setPassengerKeyforDeleteBaggage] = useState('');
    const editDivRef = useRef(null); // Reference for editBags div
    const accordionRef = useRef(null);
    const KgRef = useRef(null);
    const bagsToAddRef = useRef(null); // Reference for the "Bags to Add" select
    const addBagButtonRef = useRef(null);
    const [bagscount, setbagscount] = useState(0);
     const confirmBaggageButtonRef = useRef(null);
    const RightformRef = useRef(null);
    const formRef = useRef(null); // Form reference for focus management
    const formConfirmBaggageRef = useRef(null);
    const yesbutton = useRef(null);
    // console.log('isBagAddedInState',isBagAddedInState, isBagAddedInState <= 0);
    // console.log('AddNewBags', AddNewBags);
    // console.log('baggage component=====', isInternationalFlight(SearchedFlightDetails), selectedModule, docVerified);
    const notify = (e) =>    
        toast.error(e, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        }
    );

    let allCheckedIn = false;

    if (!isInternationalFlight(SearchedFlightDetails) && selectedModule === checkinModule) {
      const passengersForPnr = { ...SearchedFlightDetails };
      const passengerArr = passengersForPnr.passenger.filter(p => p.IsSelected);
      let selectedPassengers = passengerArr;
      allCheckedIn = selectedPassengers.filter(p => p.passengerKey).every(p => checkPassengerStatus(SearchedFlightDetails, SearchedSelectedPassengerData, p));
    }

    // initial reload focus
    useEffect(() => {
        if (bagsToAddRef.current) {
            bagsToAddRef.current.focus();
        }
    }, [])

  // shift+/right/left  && ctrl+right=>nextpage
  useEffect(() => {
    const handleKeyDown = (event) => {
         if (event.altKey && event.key.toLowerCase() === 'c') {
                    if(!IsModulAndLoginDivDisabled){
                        dispatch(moduleAndLoginDivDisabled({
                            type: "MODULE_AND_LOGINDIV_DISABLED",
                            IsModulAndLoginDivDisabled: true
                        }));
                        fncFocusElementDependsOnPathLocation(location.pathname,bagsToAddRef.current);
                    }else if (IsModulAndLoginDivDisabled) {
                        const headingDiv = document.querySelector(".modulebtn");          
                        if (headingDiv) {                
                            headingDiv.focus();
                            dispatch(moduleAndLoginDivDisabled({
                            type: "MODULE_AND_LOGINDIV_DISABLED",
                            IsModulAndLoginDivDisabled: false
                            }));
                        }
                    }
            }
            else if (event.shiftKey && event.key === "ArrowRight") {
                if( modalTitle === "Add"){        
                    event.preventDefault();
                    const firstElement = document.getElementById("bagsAdd");
                    if (firstElement) firstElement.focus();
                } 
                else if (modalTitle ==="Edit"){  
                console.log(modalTitle,"modle in edit");            
                event.preventDefault();
                KgRef.current?.focus();                
                }
            }
        else if (event.shiftKey && event.key === "ArrowLeft") {
            event.preventDefault();
            confirmBaggageButtonRef.current.focus();
        } 
        else  if (event.ctrlKey && event.key === "ArrowRight") {
            fncNextBags();
        }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [modalTitle,IsModulAndLoginDivDisabled]);

    /** effect for opening/closing side menu using shortcut keys (ALT + e)  */
    useEffect(() => {
        document.addEventListener("keydown", function (event) {  
          if (event.altKey && (event.key === 'Dead' || event.key === 'e')) {
            handleSideMenu();
          }
        })
    });

    useEffect(() => {
        if (fncCheckSearchedFlightDetailsEmpty(SearchedFlightDetails)) {
            history.push('/Search');
        }
    });

    useEffect(() => {
        document.addEventListener("keydown", shortcutKeyHandler);
        return () => {
            document.removeEventListener('keydown', shortcutKeyHandler);
        };
    });

    const shortcutKeyHandler = (event) => {
        const tag = event.target.tagName.toLowerCase();
        const isTypingField = tag === 'input' || tag === 'textarea' || event.target.isContentEditable;
        if(shortcutKeysForPageNavigation.includes(event.key)){
            const path = shortcutKeyForPage(location.pathname, event, SearchedFlightDetails);
            if (path) {
                history.push('/' + path);
            }
        }
        if (isTypingField && !event.ctrlKey) return;
        if (event.ctrlKey  && shortcutKeys.includes(event.key)) {
            if (shortcutKeysforHumburgerMenu.includes(event.key)) {
                    dispatch(redirectToPageCredentials(
                                {
                                  type: "",
                                  redirectionPage: location.pathname
                                }
                     ));
            }
            const path = shortcutKeyForPage(location.pathname, event);
            if (path) {
                history.push('/' + path);
            }
        }                          
    }

    useEffect(() => {
        if (st_UserID === 0 && selectedUser === '') {
            const firstPax = AddBags.filter(bg => bg.IsSelected)[0];
            if (firstPax && firstPax.name) {
                setSelectedUser(firstPax.name.last + "," + firstPax.name.first + " " + firstPax.name.title);
                setSelectedUSERID(firstPax.passengerKey);
            }          
        }
    }, [selectedUser, st_UserID, AddBags]);

    function fncSelectPassenger(e) {
        const val = e.target.value;
        const arr= val.split(",")
        const paxKey  = arr[0];
        const paxName = `${arr[1]}, ${arr[2]}`
        setSelectedUser(paxName);
        setSelectedUSERID(paxKey);
    }

    useEffect(() => {
        let input = document.getElementsByClassName("clsTextBoxEnterClick");
        if(input.length > 0) {
            input = input[0];
            input.addEventListener("keyup", function (event) {
                if (event.key === 'Enter') {
                    event.preventDefault();
                    document.getElementById("btnAddOrEdit").click(); 
                }
            });
        } 
       
    }, [bagsToAdd]);

    function fncNextButtonFocus() {
        document.getElementById("btnNextButtonBags").focus();
    }
 

    useEffect(() => {
        //fncNextButtonFocus();
        var Destination = [{
            "JourneyKey": "",
            "Segment": "Select a Destination",
            "SegmentKey": "",
            "IsSelected":false
        }];
        var vSearchedFlightDetails = SearchedFlightDetails.passenger;
        var vSegementDetails = SearchedFlightDetails.journeys;
        var countIsSelected =0;
        for (var i = 0; i < vSegementDetails.length; i++) {
            var segments = vSegementDetails[i].segments;
            for (var j = 0; j < segments.length; j++) {
                if (segments[j].IsSelected == true) {
                    if(countIsSelected===0)
                    {
                        Destination.push({
                            "JourneyKey": vSegementDetails[i].journeyKey,
                            "Segment": segments[j].designator.destination,
                            "SegmentKey": segments[j].segmentKey,
                            "IsSelected":true
                        })
                    }
                    else {
                        Destination.push({
                            "JourneyKey": vSegementDetails[i].journeyKey,
                            "Segment": segments[j].designator.destination,
                            "SegmentKey": segments[j].segmentKey,
                            "IsSelected":false
                        })
                    }                  
                }
            }
        }
        setSelectedDestination(Destination);
        if (SearchedFlightDetails.passenger.length > 0) {
            let isBagsAdded = (SearchedFlightDetails.passenger.length === 0 || !SearchedFlightDetails.passenger[0].name) ? false : SearchedFlightDetails.passenger.some(p => p.bags.length > 0);
            if (!isBagsAdded) {
                dispatch(lrtBagTypeCredential(
                    {
                        type: "SELECT_LRT_BAGTYPE",
                        lrtBagTypeForPassenger: {}
                    }
                ));
            }
        }
        setAddBags(SearchedFlightDetails.passenger);
        var totalBaggageFee = 0;
        var totalPassengerCount = 0;
        var TotalAllowedWeight = 0;
        var BaggageWeight = 0;
        for (var k = 0; k < vSearchedFlightDetails.length; k++) {
            if (vSearchedFlightDetails[k].IsSelected == true) {
                totalPassengerCount = totalPassengerCount + 1;
                var fee = vSearchedFlightDetails[k].fees;
                for (var l = 0; l < fee.length; l++) {
                    if (fee[l].code == 'OVERWT') {
                        totalBaggageFee = totalBaggageFee + parseInt(fee[l].totalAmount);
                    }
                }
                var bags = vSearchedFlightDetails[k].bags;
                for (var p = 0; p < bags.length; p++) {

                    var vbaggageStatus = fncBagStatus(SearchedFlightDetails, bags[p].baggageKey, vSearchedFlightDetails[k].passengerKey, "WEIGHTCHECK")
                    if (vbaggageStatus !== '' && vbaggageStatus.toUpperCase() !== "Removed".toUpperCase()) {
                        BaggageWeight = BaggageWeight + parseInt(bags[p].weight);
                    }
                }

                //new implemented on 14 july 2021
                for (var m = 0; m < vSegementDetails.length; m++) {
                    let segments = vSegementDetails[m].segments;
                    if (segments.length > 0 && segments.some(s => s.IsSelected)) {
                        for (var n = 0; n < segments[0].passengerSegment.length; n++) {
                            if (segments[0].passengerSegment[n].passengerKey == vSearchedFlightDetails[k].passengerKey) {
                                TotalAllowedWeight += parseInt(segments[0].passengerSegment[n].baggageAllowanceWeight);
                            }
                        }
                    }
                }
                // new implementation ends here
            }
        }

        var remainingWeight = 0;
        let excessWeight = 0;
        if (TotalAllowedWeight >= BaggageWeight) {
            remainingWeight = TotalAllowedWeight - BaggageWeight;
        } else {
            excessWeight = BaggageWeight - TotalAllowedWeight;
        }
        setBaggageRemaining(remainingWeight)
        setBaggageAllowance(TotalAllowedWeight);
        setExcessBaggage(excessWeight);
        setselectedPassengerCount(totalPassengerCount);


    }, [SearchedFlightDetails, AddBags]);

    useEffect(() => {
      const handleKeyDown = (e) => {
            if (e.ctrlKey && e.key === "ArrowLeft") {
            history.goBack();
            }
        };
          document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [history]);

    function getBagItemsCondition(SearchedFlightDetails, baggageKey, passengerKey, from) {
        
        const baggageStatus = fncBagStatus(SearchedFlightDetails, baggageKey, passengerKey, from);
        let returnFlag;
        if (baggageStatus === '' || (baggageStatus.toUpperCase() === 'REMOVED'.toUpperCase())) {
            returnFlag = true;
        } else {
            returnFlag = false;
        }
        return returnFlag;
    }

      const fncDelete = (JourneyKey, Baggagekey, PassengerKey) => {
            setJourneyKeyforDeleteBaggage(JourneyKey);
            setBaggageKeyforDeleteBaggage(Baggagekey);
            setPassengerKeyforDeleteBaggage(PassengerKey);
            setshowDeletePopUp(true);
          };

          const handleDeleteConfirm = () => {
            fnchandleClickDelete(JourneyKeyforDeleteBaggage, BaggageKeyforDeleteBaggage, PassengerKeyforDeleteBaggage);
            setshowDeletePopUp(false);
          };          

    function fnchandleClickDelete(JourneyKey, Baggagekey, PassengerKey) {
        // debugger
        let origin = '';
        SearchedFlightDetails.journeys.forEach(j => {
            j.segments.forEach(seg => {
                if (seg.IsSelected) {
                    origin = j.designator.origin;
                }
            });
        })
        const paxKeys = SearchedFlightDetails.passenger.filter(pax => pax.IsSelected && pax.passengerKey).map(p => p.passengerKey);
        var removeBaggages = [
            {
                "journeyKey": JourneyKey,
                "passengerKey": PassengerKey,
                "baggageKey": Baggagekey,
                "GroupPassengerKeys": paxKeys,
                "Origin": origin
            }
        ]

        fncRemoveBaggage(removeBaggages)
            .then((returnVal) => {
                   
                if (returnVal.status == "401" && returnVal.data == "") {
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    settriggerModal(true);
                }
                else {
                    if (returnVal.data.isError == false) {
                        fncSearchApiCall("REMOVE");
                        if (isBagAddedInState > 0) {
                            dispatch(bagCredential(
                                {
                                    type: "BAG_ADDED",
                                    isBagAdded: isBagAddedInState - 1
                                }
                            ));
                        }
                        
                    }
                    else {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                            settriggerModal(true);
                        } else {
                            notify(returnVal.data.errorDetail.errorMessage);
                        }
                    }
                }

            })
            .catch(err => console.log("Axios err: ", err))
    }

    function fncAddBags(UserID, Passenger) {
        setSelectedUser(Passenger)
        setModalTitle('Add')
        setSelectedUSERID(UserID)
        setShow(true);
    }

    function fncEditBags(bagType, TagNo, bagWeight, bagWeightType, taggedToStation, passengerKey, PassengerName, BaggageStatus, BaggageKey, JourneyKey) {
        var editData = {
            "BagType": bagType ? bagType: 'STND',
            "TagNo": TagNo,
            "bagWeight": bagWeight,
            "bagWeightType": bagWeightType,
            "taggedToStation": taggedToStation,
            "passengerKey": passengerKey,
            "PassengerName": PassengerName,
            "BaggageStatus": BaggageStatus,
            "BaggageKey": BaggageKey,
            "JourneyKey": JourneyKey,
            "recordLocator": SearchedFlightDetails.recordLocator
        }
        setupdatedBaggageWeightTextbox(bagWeight);
        setupdatedBagTypeValue(bagType ? bagType: 'STND');
        setEditBagsData(editData);
        setSelectedUser(PassengerName);
        setModalTitle('Edit');
        setSelectedUSERID(passengerKey);
        setShow(true);
        setTimeout(() => {
          KgRef.current.focus();
        }, 0);
    }

    function fncDestinationChange(e) {
        console.log(e);

        document.getElementById('errorLabelDestination_').textContent ="";
        if(e.target.options[e.target.selectedIndex].id !="")
        {
            const journeyKey = e.target.options[e.target.selectedIndex].id.split("~~~~")[0];
            const destination =[...st_Destination]
            for(let i=0; i<destination.length; i++)
            {
                if(destination[i].JourneyKey==journeyKey)
                {
                    destination[i].IsSelected=true; 
                }
                else{
                    destination[i].IsSelected=false; 
                }
            }
            setSelectedDestination(destination);

        }
        else {
            const journeyKey = e.target.options[e.target.selectedIndex].id;
            const destination =[...st_Destination]
            for(let i=0; i<destination.length; i++)
            {
                if(destination[i].JourneyKey==journeyKey)
                {
                    destination[i].IsSelected=true; 
                }
                else{
                    destination[i].IsSelected=false; 
                }
            }
            setSelectedDestination(destination);
        }

    }

    function fncOnNumberOfBagChange(e) {
        // debugger;

        
        document.getElementById('errorLabelNoOfBags').textContent="";
        document.getElementById('errorLabelNoOfBags1').textContent="";   
        console.log(e);
        var noOfBags = e.target.value;
        setBagsToAdd(parseInt(noOfBags));
        var NewBagsArray = [];
        var  JourneyKey ="";
        var SegmentKey="";
        var BagType ="Kilograms";

        // const bagTypes = [...st_BagTypes];
        // for(var i=0; i<bagTypes.length; i++)
        // {
        //     if(bagTypes[i].Name=="STND")
        //     {
        //         bagTypes[i].IsSelected=true; 
        //         BagType=bagTypes[i].Name;
        //     }
        //     else{
        //         bagTypes[i].IsSelected=false; 
        //     }
        // }
        // setBagTypes(bagTypes);

        if(AddNewBags.length>0)
        {
            for (let index = 0; index < AddNewBags.length; index++) {
                document.getElementById("bagWeight_"+AddNewBags[index].TagNo).value="";   
                document.getElementById("bagType_"+AddNewBags[index].TagNo).selectedIndex = "0";       
            }
        }


        for(var i=0; i<st_Destination.length; i++)
        {
            if(st_Destination[i].IsSelected==true)
            {
                JourneyKey =st_Destination[i].JourneyKey;
                SegmentKey=st_Destination[i].SegmentKey;
            }
        }

        for (var i = 0; i < noOfBags; i++) {
            NewBagsArray[i] = {
                "UserID": '',
                "TagNo": "i" + i,
                "Weight": "",
                "Type": BagType,
                "IsChecked": false,
                "JourneyKey": JourneyKey,
                "SegmentKey": SegmentKey,
                "RecordLocator":SearchedFlightDetails.recordLocator
            }
        }
        setNewBags(NewBagsArray);
    }

    function fncBagWeight(e, UserID, TagNo) {
        //    debugger;
        //    onEnterButtonClick(TagNo); 
        var Weight = e.target.value;
        if (Weight !== "") {
            if (/^[0-9]+$/.test(Weight) && Weight.length < 5) {
                var updateNewBagsArray = [...AddNewBags];
                for (var i = 0; i < updateNewBagsArray.length; i++) {
                    if (updateNewBagsArray[i].TagNo == TagNo) {
                        updateNewBagsArray[i].Weight = Weight;
                        updateNewBagsArray[i].UserID = UserID.st_UserID;
                    }
                    else{
                        updateNewBagsArray[i].UserID = UserID.st_UserID;
                    }
                }
        
                for (var i = 0; i < updateNewBagsArray.length; i++) {
                    if (updateNewBagsArray[i].Weight != "") {
                        document.getElementById('errorLabel_' + updateNewBagsArray[i].TagNo).textContent = ""
                        document.getElementById('errorLabel1_' + updateNewBagsArray[i].TagNo).textContent = ""
                    }
                }
                setNewBags(updateNewBagsArray);
                    
            }
            else{
                if (Weight.length > 4) {
                    document.getElementById('errorLabel_' +TagNo).textContent = "Please enter only 4 digit numbers";
                    document.getElementById('errorLabel1_' +TagNo).textContent = "Please enter only 4 digit numbers";
                } else {
                    document.getElementById('errorLabel_' +TagNo).textContent = "Please enter only numbers";
                    document.getElementById('errorLabel1_' +TagNo).textContent = "Please enter only numbers";
                }
            }
        }
        else {
            const updateNewBagsArray = [...AddNewBags];
            for (let i = 0; i < updateNewBagsArray.length; i++) {
                if (updateNewBagsArray[i].TagNo == TagNo) {
                    updateNewBagsArray[i].Weight = Weight;
                    updateNewBagsArray[i].UserID = UserID.st_UserID;
                }
                else
                {
                    updateNewBagsArray[i].UserID = UserID.st_UserID;
                }
            }
    
            for (let i = 0; i < updateNewBagsArray.length; i++) {
                if (updateNewBagsArray[i].Weight !== "") {
                    document.getElementById('errorLabel_' + updateNewBagsArray[i].TagNo).textContent = ""
                    document.getElementById('errorLabel1_' + updateNewBagsArray[i].TagNo).textContent = ""
                }
            }
            setNewBags(updateNewBagsArray);
            
        }
    }


    function fncBagTypeChange(e, UserID, TagNo) {
        //    debugger;
        // //fncNextButtonFocus();
        var BagType = e.target.value=="Select Bag Type"?"":e.target.value;
        // const bagTypes = [...st_BagTypes];
        var updateNewBagsArray = [...AddNewBags];
        for (let i = 0; i < updateNewBagsArray.length; i++) {
            if (updateNewBagsArray[i].TagNo == TagNo) {
                updateNewBagsArray[i].Type = BagType;
                updateNewBagsArray[i].UserID = UserID.st_UserID;
            }
        }

        for (let i = 0; i < updateNewBagsArray.length; i++) {
            if (updateNewBagsArray[i].Type != "") {
                document.getElementById('errorLabel_' + updateNewBagsArray[i].TagNo).textContent = ""
                document.getElementById('errorLabel1_' + updateNewBagsArray[i].TagNo).textContent = ""
            }
        }
        setNewBags(updateNewBagsArray);
    }

    function fncAddNewBags(AddEditType) {
        fncNextButtonFocus();
        if (AddEditType === "Add") {
            // debugger
            var updateNewBagsArray = [...AddNewBags];

                document.getElementById('errorLabelNoOfBags').textContent="";
                document.getElementById('errorLabelNoOfBags1').textContent="";
                document.getElementById('errorLabelDestination_').textContent = ""
                document.getElementById('errorLabelDestination1_').textContent = ""
                var IsError = false;
                for(let i=0; i<st_Destination.length; i++)
                {   
                    if(st_Destination[i].IsSelected && st_Destination[i].JourneyKey==="")
                    {
                        IsError=true;
                        break;
                    }
                }
                if(IsError)
                {
                    document.getElementById('errorLabelDestination_').textContent = "Please Select the Destination."
                    document.getElementById('errorLabelDestination1_').textContent = "Please Select the Destination."
                    return false;
                } 
                if(updateNewBagsArray.length ==0)
                {
                    document.getElementById('errorLabelNoOfBags').textContent="Please add bags.";
                    document.getElementById('errorLabelNoOfBags1').textContent="Please add bags.";
                     return false;     
                }   
                const pax = AddNewBags.length && SearchedFlightDetails.passenger.filter(pax => pax.passengerKey === AddNewBags[0].UserID);
                if (pax.length) {
                    const bagsCountForPax = pax[0].bags.length;
                    if (bagsCountForPax + AddNewBags.length > 10) {
                        notify('Maximum 10 bags are allowed for a single passenger');
                        return;
                    }
                }      
                //----------------------------------------------- CODE ADDED ON 23 NOV 2021 FOR BAGGAGE SPLIT ----------------------------------
                var totalNoOfBags = updateNewBagsArray.length;
                var totoalWeight = 0;
                var quotent =0;
                var reminder =0;
                var skipSplit =0;
                let overWeightBag = false;
                let zeroWeight = false;
                for (let i = 0; i < updateNewBagsArray.length; i++) {
                    if(updateNewBagsArray[i].Weight!="")
                    {
                        if (totalNoOfBags === 1) {
                            if (updateNewBagsArray[i].Weight > 32 && updateNewBagsArray[i].Weight != 0) {
                                overWeightBag = true;
                            }
                            if (updateNewBagsArray[i].Weight == 0) {
                                zeroWeight = true;
                            }                   
                        }
                        totoalWeight= totoalWeight+ parseInt(updateNewBagsArray[i].Weight);
                        skipSplit=skipSplit+1;
                    }
                }
                if(totoalWeight>=totalNoOfBags && skipSplit!=totalNoOfBags)
                {
                    if(totoalWeight%totalNoOfBags==0)
                    {
                        quotent=parseInt(totoalWeight/totalNoOfBags);
                        for (var j = 0; j < updateNewBagsArray.length; j++) {
                            updateNewBagsArray[j].Weight=quotent;
                        }
                    }
                    else
                    {
                        quotent=parseInt(totoalWeight/totalNoOfBags);
                        reminder=parseInt(totoalWeight%totalNoOfBags);
                        for (var j = 0; j < updateNewBagsArray.length; j++) {
                            if(updateNewBagsArray.length-1==j)
                            {
                                updateNewBagsArray[j].Weight=(quotent+reminder);
                            }
                            else{
                                updateNewBagsArray[j].Weight=quotent;
                            }
                        }
                    }
                }
                
                const isBagOverWeight = updateNewBagsArray.some(bg => bg.Weight > 32);

                if (isBagOverWeight && totalNoOfBags > 1) {
                    overWeightBag = true;               
                }
                
                //---------------------------------------------------- CODE ENDS HERE ----------------------------------------------------------
           
                for (var i = 0; i < updateNewBagsArray.length; i++) {
                    if (updateNewBagsArray[i].Type == "" && updateNewBagsArray[i].Weight == "") {
                        document.getElementById('errorLabel_' + updateNewBagsArray[i].TagNo).textContent = "Please add Bag Weight and Bag Type."
                        document.getElementById('errorLabel1_' + updateNewBagsArray[i].TagNo).textContent = "Please add Bag Weight and Bag Type."
                        return false;
                    }
                    else if (updateNewBagsArray[i].Type == "") {
                        document.getElementById('errorLabel_' + updateNewBagsArray[i].TagNo).textContent = "Please add Bag Type."
                        document.getElementById('errorLabel1_' + updateNewBagsArray[i].TagNo).textContent = "Please add Bag Type."
                        return false;
                    }
                    else if (updateNewBagsArray[i].Weight == "") {
                        document.getElementById('errorLabel_' + updateNewBagsArray[i].TagNo).textContent = "Please add Bag Weight."
                        document.getElementById('errorLabel1_' + updateNewBagsArray[i].TagNo).textContent = "Please add Bag Weight."
                        return false;
                    }
                }
                if (zeroWeight) {
                    notify('Weight should be greater than zero for a bag');
                }
                else if (!overWeightBag) {
                    setNewBags(updateNewBagsArray);
                    let origin = '';
                    SearchedFlightDetails.journeys.forEach(j => {
                        j.segments.forEach(seg => {
                            if (seg.IsSelected) {
                                origin = j.designator.origin;
                            }
                        });
                    })
                    var addBaggage = [];
                    const paxKeys = SearchedFlightDetails.passenger.filter(pax => pax.IsSelected && pax.passengerKey).map(p => p.passengerKey);
                    for (let i = 0; i < updateNewBagsArray.length; i++) {
                        console.log('updateNewBagsArray[i].Type', updateNewBagsArray[i].Type, lrtBagType);
                        if (updateNewBagsArray[i].Type === 'LRT') {
                            // debugger
                            if (lrtBagType[updateNewBagsArray[i].UserID]) {
                                console.log('lrtBagType[updateNewBagsArray[i].UserID]', lrtBagType[updateNewBagsArray[i].UserID])
                                lrtBagType[updateNewBagsArray[i].UserID].push({bagWeight: parseInt(updateNewBagsArray[i].Weight)});
                            } else {
                                lrtBagType[updateNewBagsArray[i].UserID] = [{bagWeight: parseInt(updateNewBagsArray[i].Weight)}];
                            }
                            
                            dispatch(lrtBagTypeCredential(
                                {
                                    type: "SELECT_LRT_BAGTYPE",
                                    lrtBagTypeForPassenger: lrtBagType
                                }
                            ));
                        }
                        addBaggage.push(
                            {
                                // "signature" : Token,
                                "journeyKey": updateNewBagsArray[i].JourneyKey,
                                "passengerKey": updateNewBagsArray[i].UserID,
                                "passengerBag":
                                {
                                    "bagCount": 1,
                                    "iataIdentifier": "",
                                    "limitedReleaseTag": updateNewBagsArray[i].Type=== 'LRT' ? true : false,
                                    "weightType": weightType, // updateNewBagsArray[i].Type,
                                    "weight": parseInt(updateNewBagsArray[i].Weight)                             
                                },
                                "GroupPassengerKeys": paxKeys,
                                Origin: origin
                            }
                        )
                    }

                    // debugger;
                    fncAddBaggage(addBaggage)
                        .then((returnVal) => {
                            // debugger;

                            if (returnVal.status == "401" && returnVal.data == "") {
                                document.getElementById("showAndHideSpinner").style.display = "none";
                                settriggerModal(true);
                            }
                            else {
                                if (!returnVal.data.isError) {
                                    // debugger;
                                    setShow(false);
                                    setNewBags([]);
                                    setBagsToAdd(0);
                                    fncSearchApiCall("REMOVE");
                                    
                                    dispatch(bagCredential(
                                        {
                                            type: "BAG_ADDED",
                                            isBagAdded: isBagAddedInState + addBaggage.length
                                        }
                                    ));
                                    if (window.innerWidth < 1024) { 
                                        const modalElement = document.getElementById('bagDetails');
                                        const modalInstance = bootstrap.Modal.getInstance(modalElement);
                                        if (modalInstance) modalInstance.hide();
                                    }
                                }
                                else {
                                    document.getElementById("showAndHideSpinner").style.display = "none";
                                    setNewBags([]);
                                    setShow(false);
                                    if (returnVal.data.errorDetail.errorMessage.indexOf('The provided token has timed out.') !== -1) {
                                        settriggerModal(true);
                                    } else {
                                        notify(returnVal.data.errorDetail.errorMessage);
                                    }                               
                                }
                            }

                        })
                        .catch(err => console.log("Axios err: ", err))
                } else {
                    notify('Weight more than 32 kgs is not allowed for a bag');
                    updateNewBagsArray.forEach(bag => {
                        bag.Weight = ''
                    })
                    setNewBags(updateNewBagsArray); 
                }           
        }
    }

    function fncCheckInBaggages(newBags, props) {
           // debugger;
        //fncNextButtonFocus();
        var checkInBaggages = [];
        var AddNewBags1 = "";
        if (props === "UPDATEBAGS") {
            setShow(false);
            const paxKeys = SearchedFlightDetails.passenger.filter(pax => pax.IsSelected && pax.passengerKey).map(p => p.passengerKey);
            AddNewBags1 = EditBagsData;
            if (AddNewBags1.bagWeight < 33 && AddNewBags1.bagWeight != 0) {
                checkInBaggages[0] = { 
                    "BaggageKey":AddNewBags1.BaggageKey,
                    "Weight":parseInt(AddNewBags1.bagWeight),
                    "WeightType": weightType,
                    "recordLocator": AddNewBags1.recordLocator,
                    "PassengerKey": AddNewBags1.passengerKey,
                    "JourneyKey": AddNewBags1.JourneyKey,
                    "GroupPassengerKeys": paxKeys,
                    "baggageTypeCode": AddNewBags1.BagType
                }
                setEditBagsData({});
    
                //   debugger;
                fncUpdateBaggage(checkInBaggages)
                .then((returnVal) => {               
        
                    // debugger;
                    if (returnVal.status == "401" && returnVal.data == "") {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        settriggerModal(true);
                    }
                    else {
        
                        if (!returnVal.data.isError) {
                            fncSearchApiCall("REMOVE");
                        }
                        else {
                            document.getElementById("showAndHideSpinner").style.display = "none";
                            if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                                settriggerModal(true);
                            } else {
                                notify(returnVal.data.errorDetail.errorMessage);
                            }
                        }
                    }
        
                })
                .catch(err => console.log("Axios err: ", err))
                if (window.innerWidth < 1024) {
                        const modalElement = document.getElementById('bagDetails');
                        const modalInstance = bootstrap.Modal.getInstance(modalElement);
                        if (modalInstance) modalInstance.hide();
                    }
            } else if (AddNewBags1.bagWeight == 0) {
                notify('Weight should be greater than zero for a bag');
            } else {
                notify('Weight more than 32 kgs is not allowed for a bag');
            }
            
        }
    }



    function fncSearchApiCall(FROM) {
        
        //fncNextButtonFocus();
           
        fncGetBookingFromState()
            .then((returnVal) => {
                if (returnVal.status == "401" && returnVal.data == "") {
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    settriggerModal(true);
                }
                else {

                    if (returnVal.data.isError == false) {
                        if (returnVal.data.flightDetails != null) {
                            var assignStateAgain = fncAssignSearchedCheckboxes(SearchedSelectedPassengerData, returnVal.data.flightDetails, "AUTOSEATASSIGN");
                        }
                        dispatch(searchCredential(
                            {
                                type: "",
                                SearchedRecordData: stSearchedRecordData,
                                SearchedFlightDetails: assignStateAgain
                            }
                        ));
                        if (FROM === "REMOVE") {
                            setModalTitle('Add');
                        }
                    }
                    else {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                            settriggerModal(true);
                        } else {
                            notify(returnVal.data.errorDetail.errorMessage);
                        }
                    }
                    document.getElementById("showAndHideSpinner").style.display = "none";
                }

            })
            .catch(err => console.log("Axios err: ", err))
    }
    function fncUpdateBags() {
        fncCheckInBaggages(SearchedFlightDetails, "UPDATEBAGS");
    }

    function closeAddBagModal() {
        setBagsToAdd(0);
        setNewBags([]);
    }

    function fncWeightUpdate(e) {
        //    debugger;
        const BagsData = EditBagsData;
        console.log(updatedBaggageWeightTextbox)
        var value = e.target.value;
        if (value !== "") {
            if (/^[0-9]+$/.test(value)) {
                setEditBagsData({});
                // var id = e.target.id;
                BagsData.bagWeight = value;
                setEditBagsData(BagsData);
                setupdatedBaggageWeightTextbox(value);
            }
        } 
        else {
            setEditBagsData({});
            BagsData.bagWeight = value;
            setEditBagsData(BagsData);
            setupdatedBaggageWeightTextbox(value);
        }
        
    }

    function fncSelectJourney() {
        var JourneyKey = "";
        for (var i = 0; i < SearchedFlightDetails.journeys.length; i++) {
            var segments = SearchedFlightDetails.journeys[i].segments;
            for (var j = 0; j < segments.length; j++) {
                if (segments[j].IsSelected) {
                    JourneyKey = SearchedFlightDetails.journeys[i].journeyKey;
                }
            }
        }
        return JourneyKey;
    }

    function fncComfirmBaggage() {
        const paxKeys = SearchedFlightDetails.passenger.filter(pax => pax.IsSelected && pax.passengerKey).map(p => p.passengerKey);
        const apiBody = {
            journeyKey: fncGetJourneyKey(),
            GroupPassengerKeys: paxKeys,
            RoleCode: RoleCode
        }
        fncConfirmBaggageApi(apiBody)
        .then((returnVal) => {
            if (returnVal.status == "401" && returnVal.data == "") {
                document.getElementById("showAndHideSpinner").style.display = "none";
                settriggerModal(true);
            }
            else {

                if (!returnVal.data.isError && returnVal.data.isBaggageConfirmed) {
                    // document.getElementById("showAndHideSpinner").style.display = "block";
                    fncSearchApiCall("REMOVE");
                }
                else {
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                        settriggerModal(true);
                    } else {
                        notify(returnVal.data.errorDetail.errorMessage);
                    }
                }
                // document.getElementById("showAndHideSpinner").style.display = "none";
            }

        })
        .catch(err => console.log("Axios err: ", err))
    }

    function fncNextBags() {
        var navPage = fncPageNavigations(UserRights,"Bags",SearchedFlightDetails)
        history.push("/"+navPage);
    }

    function fncGetJourneyKey()
    {
        for(var i=0; i<SearchedFlightDetails.journeys.length ; i++)
        {
            var segment = SearchedFlightDetails.journeys[i].segments;
            for(var j=0; j<segment.length; j++)
            {
                if(segment[j].IsSelected)
                {
                    return SearchedFlightDetails.journeys[i].journeyKey
                }
            }
        }
    }

    function fncmobileAddorEdit() {
        if (modalTitle === 'Add') {
            fncAddNewBags(modalTitle);
        } else {
            fncUpdateBags();
        }
    }
    
    // for to move tab at Add bags as we wantz
useEffect(() => {
  if (modalTitle === "Add") {
    const handleKeyDown = (e) => {
        if (e.key === "Tab") {
            const focusableElements = RightformRef.current.querySelectorAll("select, input");
            const focusable = Array.from(focusableElements).filter((el) => !el.disabled);
            const firstElement = focusable[0];
            const lastElement = focusable[focusable.length - 1];
            const currentIndex = focusable.indexOf(document.activeElement);
            
         // Handle Shift + Tab (Backward)

                if (e.shiftKey) {
                    if (document.activeElement === firstElement) {
                        e.preventDefault();
                        lastElement.focus();
                    }
                } 
        
      // Handle Tab (Forward)
                else {
                    if (document.activeElement === lastElement) {
                        e.preventDefault();
                        firstElement.focus();
                    } else if (document.activeElement.id === "destination" && !e.shiftKey) {
                        e.preventDefault();
                        addBagButtonRef.current?.focus(); // Move focus to the "Add Bags" button
                    }else if (document.activeElement.id === "btnAddOrEdit" && !e.shiftKey) {
                        e.preventDefault();
                        bagsToAddRef.current?.focus();
                    }
                }
        }
    };
        const container = RightformRef.current;
        if (container) {
            container.addEventListener("keydown", handleKeyDown);
        }
            return () => {
                if (container) {
                    container.removeEventListener("keydown", handleKeyDown);
                }       
            };
}
}, [modalTitle]);

 // leftdiv  trap focus
    useEffect(() => {
        const handleKeyDown = (e) => {
                    if (!accordionRef.current) return;
                // Select only `<a>` and `<button>` elements inside the accordion
                    const focusableElements = accordionRef.current.querySelectorAll('a, button');
                    const focusable = Array.from(focusableElements).filter((el) => !el.disabled && el.offsetParent !== null);
                    if (focusable.length === 0) return;
                    const currentIndex = focusable.indexOf(document.activeElement);
                    const firstElement = focusable[0];
                    const lastElement = focusable[focusable.length - 1];
                if (e.key === "Tab") {
                    if (e.shiftKey) {
                    // Shift + Tab (Backward)
                        if (document.activeElement === firstElement) {
                        e.preventDefault();
                        lastElement.focus();
                        }
                    } else {
                    // Tab (Forward)
                            if (document.activeElement === lastElement) {
                                e.preventDefault();
                                firstElement.focus();
                            }
                        }
                }
      };    

            const container = accordionRef.current;
            if (container) {
                container.addEventListener("keydown", handleKeyDown);
            }   

            return () => {
                if (container) {
                container.removeEventListener("keydown", handleKeyDown);
                }
            };
    }, []);
       
    const handleKeyDownForEditBags = (e) => {
        if (e.key === "Tab") {
            const focusableElements = editDivRef.current.querySelectorAll('input, button, [tabindex]:not([tabindex="-1"])');
            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];

            if (!e.shiftKey && document.activeElement === lastElement) {
                e.preventDefault();
                firstElement.focus();
            } else if (e.shiftKey && document.activeElement === firstElement) {
                e.preventDefault();
                lastElement.focus();
            }
        }
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Tab") {
                if (document.activeElement.id === "NoDeleteBtn" && !e.shiftKey) {
                e.preventDefault();
                yesbutton.current?.focus();
                }
            }
        }
            document.addEventListener("keydown", handleKeyDown);
            return () => {
            document.removeEventListener("keydown", handleKeyDown);
            };
    });

    useEffect(() => {
          if (showDeletePopUp) {
            yesbutton.current.focus();
          }
    }, [showDeletePopUp]);

    const checkIfPassengerBoarded = (paxKey = st_UserID) => {
        return SearchedFlightDetails.journeys.some((jou) =>
            jou.segments.some((seg, i) =>
              seg.IsSelected && seg.passengerSegment.some((paxseg) =>
                paxseg.passengerKey === paxKey && paxseg.IsSelected && paxseg.liftStatus == "Boarded"
              )
            )
        );
    }

    return (
        <div inert>
        <Modal
            show={showDeletePopUp}
            onHide={() => setDeletePopup(false)}
            backdrop="static"
            keyboard={false}
            centered
            dialogClassName="bottom-dialog-modal"
        > 
            <Modal.Header>
                <Modal.Title>Are you sure?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>You want to delete?</p>
            </Modal.Body>
    <Modal.Footer>
        <Button
        variant="secondary"
        ref={yesbutton}
        className="confirm-btn OrangeShadow"
        onClick={handleDeleteConfirm}
        >
            Yes, Delete it!
        </Button>
        <Button id="NoDeleteBtn"
        variant="danger"
        className="cancel-btn OrangeShadow"
        onClick={() => setshowDeletePopUp(false)}
        >
        No
        </Button>
    </Modal.Footer>
</Modal>
        <div>
            <div class="seat-container">
                <LogoutModel trigger={triggerModal}> </LogoutModel>
                <DocumentVerificationModal trigger={!isInternationalFlight(SearchedFlightDetails) && selectedModule === checkinModule && !docVerified && !allCheckedIn && haveTravelDocs(SearchedFlightDetails)}></DocumentVerificationModal>
                <div class="row">
                    <div class="col-lg-8">
                        <div class="leftDetail-data" ref={formConfirmBaggageRef}>
                            <div class="pTable-data-outer bagData">
                                <div class="heading">
                                    <h4 class="font-xxl bold dark-text mb-0">
                                        Bags Group 1 <span class="font-md regular">({st_selectedPassengerCount} Passengers)</span>
                                    </h4>
                                </div>
                                <div class="bags-heading">
                                    <div class="bags-heading-item">
                                        <p class="font-sm bold mb-1">Name</p>
                                        <p class="font-md mb-0">Travel Bag</p>
                                    </div>
                                    <div class="bags-heading-item">
                                        <p class="font-sm bold mb-1">Allowance</p>
                                        <p class="font-md mb-0">{st_BaggageAllowance}</p>
                                    </div>
                                    <div class="bags-heading-item">
                                        <p class="font-sm bold mb-1">Remaining</p>
                                        <p class="font-md mb-0">{st_BaggageRemaining}</p>
                                    </div>
                                    <div class="bags-heading-item">
                                        <p class="font-sm bold mb-1">Excess</p>
                                        <p class="font-md mb-0">{st_ExcessBaggage}</p>
                                    </div>
                                    <div class="bags-heading-item">
                                    <button disabled={isBagAddedInState <= 0} className="btn btn-primary SerachBtn btn-animation"ref={confirmBaggageButtonRef} onClick={fncComfirmBaggage}  >Confirm Baggage</button>
                                    </div>
                                </div>
                                <div class="pTable border-t-1">
                                    <div class="accordion pTableAccordion" ref={accordionRef} id="accordionExample">
                                        {
                                            AddBags.length == 0 ? "" : AddBags.map((item, i) =>
                                            item.IsSelected == true ?
                                            <div class="accordion-item" key={i}>
                                                <h2 class="accordion-header" id={`heading${item.name.first}`}>
                                                    <a className={`accordion-button btn-animtion focusClass collapsed`} tabIndex={0} type="button" data-bs-toggle="collapse" data-bs-target={`#collapse${item.name.first}`} aria-expanded="true"  aria-controls={`collapse${item.name.first}`}
                                                       onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                    const allButtons = document.querySelectorAll(".accordion-button");
                                                                    const allCollapseElements = document.querySelectorAll(".collapse");
                                                                    const currentButton = e.currentTarget;
                                                                    const target = document.querySelector(`#collapse${item.name.first}`);                                                
                                                                    // add 'collapsed' class from all buttons
                                                                    allButtons.forEach((btn) => btn.classList.add("collapsed"));                                                  
                                                                // Hide all collapse elements except the target
                                                                    allCollapseElements.forEach((element) => {
                                                                            if (element.id !== `collapse${item.name.first}`) {
                                                                                element.classList.remove("show");                     
                                                                            }
                                                                        }
                                                                    );                                                
                                                                    if (target) {
                                                                    target.classList.toggle("show");
                                                                    currentButton.classList.toggle("collapsed", !target.classList.contains("show"));
                                                                    }
                                                            }                                                  
                                                       }
                                                    }>
                                                    {item.name.last + "," + item.name.first + " " + item.name.title}
                                                    </a>
                                                    <a tabIndex={0} data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#bagDetails" onClick={() => { fncAddBags(item.passengerKey, item.name.last + "," + item.name.first + " " + item.name.title) }} class="addNewBag-btn d-lg-none d-inline-block btn-primary focusClass  SerachBtn">
                                                        Add Bag
                                                    </a>
                                                </h2>

                                                <div id={`collapse${item.name.first}`} class="accordion-collapse collapse show" aria-labelledby={`heading${item.name.first}`} data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                    <div class="ptable-data">
                                                            <div class="headings">
                                                                <div class="destination">Destination</div>
                                                                <div class="bagId">Bag ID</div>
                                                                <div class="weight">Weight (KG)</div>
                                                                <div class="bagType">Bag Type</div>
                                                                <div class="status">Status</div>
                                                                <div class="action">Action</div>
                                                            </div>
                                                        
                                                            <div class="pTable-scroll-body mb-0">
                                                            {item.bags.length == 0 ? "" : item.bags.map((bags, j) => getBagItemsCondition(SearchedFlightDetails, bags.baggageKey, item.passengerKey, "WEIGHTCHECK") ? "" :
                                                    
                                                                <div class=" table-item bag-item" key={j}>
                                                                    <div class="destination">
                                                                        <label>Destination</label>
                                                                        <p>{bags.taggedToStation} </p>
                                                                    </div>
                                                                    <div class="bagId">
                                                                        <label>Bag Id</label>
                                                                        <p>{bags.osTag}</p>
                                                                    </div>
                                                                    <div class="weight"> <label>Weight (KG)</label>
                                                                        <p>{bags.weight}</p>
                                                                    </div>
                                                                    <div class="bagType"> <label>Bag Type</label>
                                                                        <p>{bags.type ? bags.type: 'STND'}</p>
                                                                    </div>
                                                                    <div class="status"> <label>Status</label>
                                                                        <p>{fncBagStatus(SearchedFlightDetails, bags.baggageKey, item.passengerKey, "")}</p>
                                                                    </div>
                                                                    <div class={checkIfPassengerBoarded(item.passengerKey) ? "action disabled-div" : "action"}>
                                                                        <button class="icon-btn focusClass checkbox-input"
                                                                        {...(w <= 1024 ? { "data-bs-toggle": "modal", "data-bs-target": "#bagDetails" } : {})}
                                                                        title="Edit"
                                                                        onClick={() => {
                                                                            fncEditBags(bags.type, bags.osTag, bags.weight, bags.weightType, bags.taggedToStation, item.passengerKey, item.name.last + "," + item.name.first + " " + item.name.title, fncBagStatus(SearchedFlightDetails, bags.baggageKey, item.passengerKey, ""), bags.baggageKey
                                                                            ,
                                                                                fncSelectJourney()
                                                                            )
                                                                        }}
                                                                        >
                                                                            <img alt="" src="newImages/icon-edit.svg" />
                                                                        </button>
                                                                        <button
                                                                        class="icon-btn focusClass checkbox-input"
                                                                        data-bs-toggle="tooltip"
                                                                        data-bs-html="true"
                                                                        title="Delete"
                                                                        onClick={() => {fncDelete(
                                                                                fncGetJourneyKey(),
                                                                                bags.baggageKey, item.passengerKey)
                                                                        }}
                                                                        >
                                                                            <img alt="" src="newImages/icon-delete.svg" />
                                                                        </button>

                                                                    </div>
                                                                </div> 
                                                                )}                                           
                                                            </div>
                                                        
                                                        
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            : ""
                                            )
                                        }                                   
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 d-none d-lg-block">
                        {
                            modalTitle === 'Add' ?
                            <div>
                            <div class="rightDetail-data bagDetails-data" ref={RightformRef}>
                            
                                <div class="bagDetails">
                                    <div class="d-flex justify-content-between">
                                    <h4 class="font-xxl bold dark-text mb-3">Bags Detail</h4>
                                    <button id="btnAddOrEdit" tabIndex={(AddNewBags.length>=1)?0:-1} ref={addBagButtonRef}class="focusClass btn btn-primary addBagTop btn-animation  SerachBtn" disabled={checkIfPassengerBoarded()} onClick={() => { fncAddNewBags(modalTitle) }}>
                                        <span class="px-4">Add Bags</span>
                                    </button>
                                    </div>
                                    <div class="bagform">
                                    <div class="form-floating mb-4">
                                        <select class="form-select focusClass" id="passenger" onChange={e => fncSelectPassenger(e)} aria-label="Passenger">
                                        { 
                                            (AddBags.length === 0 || !AddBags[0].name) ? "" : AddBags.filter(bg => bg.IsSelected).map((item, i) =>
                                                <option key={i} value={item.passengerKey +"," +item.name.last + "," + item.name.first + " " + item.name.title}>{item.name.last + "," + item.name.first + " " + item.name.title}</option>
                                            )
                                        }
                                        </select>
                                        {/* <input type="text" class="form-control" id="fname" placeholder="First Name" /> */}
                                        <label class="bold" for="pname">Passenger Name</label>
                                    </div>
                                    <div class="row">
                                        <div class="col-6 mb-4">
                                            <div class="form-floating">
                                                <select class="form-select focusClass" id="destination" onChange={e => fncDestinationChange(e)} aria-label="Destination">
                                                    { 
                                                        st_Destination.length == 0 ? '' : st_Destination.map((dest, i) =>
                                                            <option key={i} id={dest.JourneyKey + "~~~~" + dest.SegmentKey} selected={dest.IsSelected}>{dest.Segment}</option>
                                                        )
                                                    }
                                                </select>
                                                <label class="bold" for="departure">Destination</label>
                                                <span className="clsError" id={"errorLabelDestination_"}></span>
                                            </div>
                                        </div>
                                        <div class="col-6 mb-4">
                                            <div class= {checkIfPassengerBoarded() ? "form-floating disabled-div" : "form-floating" }>
                                            {/* <div class="form-floating"> */}
                                                <select ref={bagsToAddRef}
                                                class="form-select focusClass"
                                                id="bagsAdd"
                                                value={bagsToAdd}
                                                onChange={e => fncOnNumberOfBagChange(e)
                                                } aria-label="BagsToAdd"
                                                >
                                                    <option value="0">0</option>
                                                    <option value="1">1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                    <option value="5">5</option>
                                                    <option value="6">6</option>
                                                    <option value="7">7</option>
                                                    <option value="8">8</option>
                                                    <option value="9">9</option>
                                                    <option value="10">10</option>
                                                </select>
                                                <label class="bold focusClass" for="departure">Bags to Add</label>
                                            </div>
                                            <span className="clsError" id="errorLabelNoOfBags" ></span>
                                        </div>
                                    </div>
                                    <div class="bagDetails-items">
                                        {
                                            AddNewBags.length === 0 ? '' :
                                            AddNewBags.map((item, i) =>
                                            <div>
                                                <div class="row mb-4">
                                                    <div class="numb col-1 align-items-center d-flex">
                                                        <p class="font-md semibold mb-0">{i + 1}.</p>
                                                    </div>
                                                    <div class="weight col-3 d-flex align-items-center">
                                                        <input id={"bagWeight_"+item.TagNo} value={item.Weight} type="text" onChange={(e) => fncBagWeight(e, { st_UserID }, item.TagNo)} class="form-control inputGrey clsTextBoxEnterClick" />
                                                        <span class="text-color-black text-nowrap sp-formFieldUnit-right">KG</span>
                                                    </div>
                                                    <div class="type col-8">
                                                        {/* <select class="form-select inputGrey" id={"bagType_"+item.TagNo} onChange={(e) => fncBagTypeChange(e, { st_UserID }, item.TagNo)} aria-label="BagType"> */}
                                                        <select class="form-select" id={"bagType_"+item.TagNo} onChange={(e) => fncBagTypeChange(e, { st_UserID }, item.TagNo)} aria-label="BagType">
                                                            {
                                                                st_BagTypes.length == 0 ? '' : st_BagTypes.map((dest, j) =>
                                                                    <option key={j} id={dest.Name} >{dest.Name}</option>
                                                                )
                                                            }
                                                        </select>
                                                    </div>
                                                </div> 
                                                <div>
                                                    <span className="clsError" id={"errorLabel_" + item.TagNo}></span>
                                                </div>
                                            </div>
                                            )
                                        }                               
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                            
                            </div> :
                            <div className="editBags" ref={editDivRef}tabIndex={-1} onKeyDown={handleKeyDownForEditBags}>
                            <div class="rightDetail-data bagDetails-data">
                                <div class="bagDetails">
                                    <h4 class="font-xxl bold dark-text mb-3 focusClass">Bags Detail</h4>
                                    <div class="bagform">
                                        <div class="row">
                                        
                                                <div class="col-12 mb-4">
                                                    <div class="form-floating">
                                                        <div class="form-control">{selectedUser}</div>
                                                        <label class="bold" for="fname">Passenger Name</label>
                                                    </div>
                                                </div> 
                                                <div class="col-12 mb-4">
                                                <div class="form-floating">
                                                    <div class="form-control">{EditBagsData.TagNo}</div>
                                                    <label class="bold" for="fname">Bag Tag</label>
                                                    </div>
                                                </div>
                                                <div class="col-6 mb-4">
                                                <div class="form-floating">
                                                    <div class="form-control">{EditBagsData.taggedToStation}</div>
                                                    <label class="bold" for="fname">Destination</label>
                                                    </div>
                                                </div>
                                                <div class="col-6 mb-4">
                                                <div class="form-floating">
                                                    <div class="form-control">{EditBagsData.BaggageStatus}</div>
                                                    <label class="bold" for="fname">Status</label>
                                                    </div>
                                                </div>
                                                <div class="col-6 mb-4">
                                                <div class="form-floating">
                                                        <div class="form-control d-flex align-items-center">
                                                            <input class="inputStyleNone not-empty" ref={KgRef} type="text" onChange={(e) => fncWeightUpdate(e)} value={updatedBaggageWeightTextbox} />
                                                            <span class="text-color-black text-nowrap sp-formFieldUnit-right">kg</span>
                                                        </div>
                                                        <label class="bold" for="fname">Bag</label>
                                                    </div>
                                                </div>
                                                <div class="col-6 mb-4">
                                                <div class="form-floating">
                                                    <input class="form-control not-empty" type="text" placeholder="Bag Type" value={updatedBagTypeValue} />                                               
                                                    <label class="bold" for="fname">Bag Type</label>
                                                    </div>
                                                </div>                                                                                  
                                            
                                        </div>
                                        
                                    </div>
                                </div>
                                </div>
                                <button id="btnAddOrEdit" class="btn btn-primary addBags-btn me-4 SerachBtn" onClick={fncUpdateBags}>
                                    <span class="px-4">Edit Bags</span>
                                </button>
                                <button class="btn btn-primary me-4  btn-animation input-box SerachBtn" onClick={() => setModalTitle('Add')} >
                                  <span class="px-4">Cancel</span>
                                </button>
                            </div>
                        }
                    </div>
                </div>
                <div class="btn-container mobile-fix-bottom">
                    <a tabIndex={-1} class="btn btn-primary-dark" onClick={() => history.goBack()}>
                        <span class="px-4"><span class="icon me-2" ><img class=" rotate180" src="newImages/i-arrow-right.svg" /> <img class=" rotate180" src="newImages/i-arrow-right.svg" /></span>Previous</span>
                    </a>
                    <button class="focusClass btn btn-secondary btn-animation" id="btnNextButtonBags" onClick={fncNextBags} tabIndex={-1}>
                        <span class="px-4"> Next<span class="icon ms-2"><img src="newImages/i-arrow-right.svg" /> <img src="newImages/i-arrow-right.svg" /></span></span>
                    </button>
                </div>
            </div>
            <div class="modal fade " id="bagDetails" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true" data-bs-backdrop="static">
                <div class="modal-dialog modal-dialog-centered seat-modal">
                    <div class="modal-content px-3">
                        <div class="heading">
                            <a data-bs-dismiss="modal" class="modal-close" onClick={() => closeAddBagModal()} >
                                <img src="newImages/i-cross.svg" alt="cross" />
                            </a>
                            <h4 class="font-xxl bold dark-text mb-0">Bags Detail</h4>
                        </div>
                        {
                            modalTitle === 'Add' ?
                            <div class="bagDetails px-0 py-1">
                                <div class="bagform">
                                    <div class="form-floating mb-4">
                                        <input class="form-control not-empty" required value={selectedUser} placeholder="First Name" />
                                        <label class="bold" for="fname">Passanger Name</label>
                                    </div>
                                    <div class="row">
                                        <div class="col-6 mb-4">
                                            <div class="form-floating">
                                                <select class="form-select not-empty" id="destination" onChange={e => fncDestinationChange(e)} aria-label="Destination">
                                                    {
                                                        st_Destination.length == 0 ? '' : st_Destination.map((dest, i) =>
                                                            <option id={dest.JourneyKey + "~~~~" + dest.SegmentKey} selected={dest.IsSelected}>{dest.Segment}</option>
                                                        )
                                                    }
                                                </select>
                                                <label class="bold" for="departure">Destination</label>
                                                <span className="clsError" id={"errorLabelDestination1_"}></span>
                                            </div>
                                        </div>
                                        <div class="col-6 mb-4">
                                            <div class="form-floating">
                                                <select
                                                class="form-select"
                                                aria-label="Bags To Add"
                                                value={bagsToAdd}
                                                onChange={e => fncOnNumberOfBagChange(e)}
                                                >
                                                    <option value="0">0</option>
                                                    <option value="1">1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                    <option value="5">5</option>
                                                    <option value="6">6</option>
                                                    <option value="7">7</option>
                                                    <option value="8">8</option>
                                                    <option value="9">9</option>
                                                    <option value="10">10</option>
                                                </select>
                                                <label class="bold" for="departure">Bags to Add</label>
                                            </div>
                                            <span className="clsError" id="errorLabelNoOfBags1" ></span>
                                        </div>
                                    </div>
                                    {
                                        AddNewBags.length == 0 ? '' :
                                        AddNewBags.map((item, i) =>
                                        <div class="bagDetails-items">
                                            <div class="row mb-4">
                                                <div class="numb col-1 align-items-center d-flex">
                                                    <p class="font-md semibold mb-0">{i + 1}.</p>
                                                </div>
                                                <div class="weight col-3">
                                                    <div class="d-flex align-items-center">
                                                    <input type="text" class="form-control inputGrey" id={"bagWeight_"+item.TagNo} value={item.Weight} onChange={(e) => fncBagWeight(e, { st_UserID }, item.TagNo)} name="weight" placeholder="" />
                                                    <span class="text-color-black text-nowrap sp-formFieldUnit-right ms-2">KG</span>
                                                    </div>
                                                </div>
                                                <div class="type col-8">
                                                    <select class="form-select inputGrey not-empty" id={"bagType_"+item.TagNo} onChange={(e) => fncBagTypeChange(e, { st_UserID }, item.TagNo)} aria-label="BagType">
                                                    {
                                                        st_BagTypes.length == 0 ? '' : st_BagTypes.map((dest, i) =>
                                                            <option id={dest.Name} >{dest.Name}</option>
                                                        )
                                                    }
                                                    </select>
                                                </div>
                                                <span className="clsError text-danger small mt-1 d-block" id={"errorLabel1_" + item.TagNo}> </span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div> 
                        :
                        <div class="bagDetails px-0 py-1">
                            <div class="bagform">
                                <div class="row">    
                                    <div class="col-12 mb-4">
                                        <div class="form-floating">
                                            <div class="form-control">{selectedUser}</div>
                                            <label class="bold" for="fname">Passenger Name</label>
                                        </div>
                                    </div> 
                                    <div class="col-12 mb-4">
                                    <div class="form-floating">
                                        <div class="form-control">{EditBagsData.TagNo}</div>
                                        <label class="bold" for="fname">Bag Tag</label>
                                        </div>
                                    </div>
                                    <div class="col-7 mb-4">
                                    <div class="form-floating">
                                        <div class="form-control">{EditBagsData.taggedToStation}</div>
                                        <label class="bold" for="fname">Destination</label>
                                        </div>
                                    </div>
                                    <div class="col-5 mb-4">
                                    <div class="form-floating">
                                        <div class="form-control">{EditBagsData.BaggageStatus}</div>
                                        <label class="bold" for="fname">Status</label>
                                        </div>
                                    </div>
                                    <div class="col-7 mb-4">
                                    <div class="form-floating">
                                            <div class="form-control d-flex align-items-center">
                                                <input class="inputStyleNone not-empty" type="number" onChange={(e) => fncWeightUpdate(e)} value={updatedBaggageWeightTextbox} />
                                                <span class="text-color-black text-nowrap">kg</span>
                                                {/* <span class="text-color-black text-nowrap sp-formFieldUnit-right">kg</span> */}
                                            </div>
                                            <label class="bold" for="fname">Bag</label>
                                        </div>
                                    </div>
                                    <div class="col-5 mb-4">
                                    <div class="form-floating">
                                        <input class="form-control not-empty" type="text" placeholder="Bag Type" value={updatedBagTypeValue} />                                               
                                        <label class="bold" for="fname">Bag Type</label>
                                        </div>
                                    </div>    
                                </div>
                            </div>
                        </div>
                        }
                        <div class="btn-container">
                            <a data-bs-dismiss="modal" class="btn btn-primary-dark" onClick={() => closeAddBagModal()}>
                                <span class="px-4">Close</span>
                            </a>
                            <button id="btnAddOrEdit" class="btn btn-primary addBags-btn" onClick={fncmobileAddorEdit}>
                                <span class="px-4">{modalTitle} Bag</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
    </div>
    </div>
    );
}

export default Bags;